import { render } from "./addBilling.vue?vue&type=template&id=41528191&scoped=true"
import script from "./addBilling.vue?vue&type=script&lang=js"
export * from "./addBilling.vue?vue&type=script&lang=js"

import "./addBilling.vue?vue&type=style&index=0&id=41528191&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41528191"]])

export default __exports__